import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Motives from './Motives';
import { useMotivesStyles } from '../styles';
import MotiveMobileMapper from '../mobile/MotiveMobileMapper';

const MotiveList = ({ ...props }) => {
  const { motives, mobile } = props;
  const classes = useMotivesStyles();

  return (
    <Box
      width="100%"
      marginLeft={8}
      marginRight={8}
      display="flex"
      flexDirection="column"
    >
      {mobile &&
        motives.map((motive, index) => (
          <div className={classes.motiveContainer} key={index}>
            <MotiveMobileMapper title={motive.title} motiveId={motive.id} />
          </div>
        ))}
      {!mobile && <Motives motives={motives} />}
    </Box>
  );
};

MotiveList.propTypes = {
  motives: PropTypes.array,
  mobile: PropTypes.bool,
};

export default MotiveList;
